import { useDispatch } from "react-redux";
import { setSnackbar } from "reduxStore/state";
import * as Yup from "yup";
import {
  updateOrganisation,
  createOrganisation,
} from "reduxStore/actions/organisationActions";

export const useOrgForm = ({ editMode, currentOrg, setOpen }) => {
  const dispatch = useDispatch();

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Organisation Name is required"),
    description: Yup.string().required("Description is required"),
  });

  const initialValues = {
    name: currentOrg ? currentOrg.name : "",
    description: currentOrg ? currentOrg.description : "",
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const orgId = currentOrg?._id;
      let response;

      if (editMode) {
        response = await dispatch(updateOrganisation(orgId, values));
      } else {
        response = await dispatch(createOrganisation(values));
      }

      const isSuccess = response && !response.error;

      dispatch(
        setSnackbar({
          open: true,
          message: isSuccess
            ? editMode
              ? "Organisation updated successfully"
              : "Organisation created successfully"
            : response.error || "Something went wrong",
          severity: isSuccess ? "success" : "error",
        })
      );

      if (isSuccess) {
        resetForm();
        setOpen(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return {
    validationSchema,
    initialValues,
    handleSubmit,
  };
};
